import React from 'react';
import './Loader.css';

const Loader = React.memo(() => {
  return <span className="Loader" />;
});

export default Loader;
